function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
import React, { useEffect, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { useSize } from "ahooks";
import { effect, useSignal } from "@preact/signals-react";
import styles from "./PDFPreview.module.scss";
import { PDFPrev } from "./PDFPrev";
import { PDFNext } from "./PDFNext";
import cls from "classnames";
import VirtualList from "rc-virtual-list";
import { List } from "antd";
pdfjs.GlobalWorkerOptions.workerSrc = "//unpkg.com/pdfjs-dist@".concat(pdfjs.version, "/legacy/build/pdf.worker.min.js");
var DataItem = /*#__PURE__*/_createClass(function DataItem(index) {
  _classCallCheck(this, DataItem);
  this.index = index;
});
var PageSize = /*#__PURE__*/_createClass(function PageSize(originalWidth, originalHeight) {
  _classCallCheck(this, PageSize);
  this.originalWidth = originalWidth;
  this.originalHeight = originalHeight;
});
export function PDFPreview(_ref) {
  var _contentSize$height, _contentSize$height2;
  var createBlobUrl = _ref.createBlobUrl,
    noWheelClassName = _ref.noWheelClassName;
  var contentRef = useRef(null);
  var contentSize = useSize(contentRef);
  var numPages = useSignal(0);
  var pageNumber = useSignal(1);

  /// pdf 当前尺寸及原始尺寸
  var pageSize = useSignal(new PageSize());
  var pageScale = useSignal(0.3);
  var previewDataList = useSignal(new Array());
  var documentLoaded = useSignal(false);
  var noWheelContainerClass = cls(styles.container, noWheelClassName);
  useEffect(function () {
    previewDataList.value = Array.from({
      length: numPages.value
    }, function (val, i) {
      return new DataItem(i + 1);
    });
  }, [numPages.value]);
  effect(function () {
    if (!pageSize.value.originalHeight) {
      return;
    }
    if (!pageSize.value.originalWidth) {
      return;
    }
    if (!contentSize) {
      return;
    }
    var contentWidth = contentSize.width - 20 > 250 ? contentSize.width - 20 : 250;
    var contentHeight = contentSize.height - 20 > 250 ? contentSize.height - 20 : 250;

    /// 高 > 宽
    if (pageSize.value.originalHeight > pageSize.value.originalWidth) {
      var scale = contentHeight / pageSize.value.originalHeight;
      if (pageSize.value.originalWidth * scale > contentWidth) {
        scale = contentWidth / pageSize.value.originalWidth;
      }
      pageScale.value = scale;
    } else {
      var _scale = contentWidth / pageSize.value.originalWidth;
      if (pageSize.value.originalHeight * _scale > contentHeight) {
        _scale = contentHeight / pageSize.value.originalHeight;
      }
      pageScale.value = _scale;
    }
  });
  function onPageLoadError(error) {
    console.log("load error", error);
  }
  function onPageLoadSuccess(originalWidth, originalHeight) {
    pageSize.value = new PageSize(originalWidth, originalHeight);
  }
  function onDocumentLoadError(error) {
    console.log("load error", error);
  }
  function onDocumentLoadSuccess(pages) {
    documentLoaded.value = true;
    numPages.value = pages;
  }
  function handleDocumentPrev() {
    var prevPage = pageNumber.value - 1;
    if (prevPage < 1) {
      return;
    }
    pageNumber.value = prevPage;
  }
  function handleDocumentNext() {
    var nextPage = pageNumber.value + 1;
    if (nextPage > numPages.value) {
      return;
    }
    pageNumber.value = nextPage;
  }
  function handlePageNumClicked(num) {
    pageNumber.value = num;
  }
  function renderItem(item) {
    if (!createBlobUrl) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.container
      }, "Upload error");
    }
    return /*#__PURE__*/React.createElement("div", {
      key: item.index,
      className: "".concat(styles.pdfPreviewItem, " ").concat(pageNumber.value === item.index ? styles.pdfPreviewItemSelected : styles.pdfPreviewItemUnselected),
      onClick: function onClick() {
        return handlePageNumClicked(item.index);
      }
    }, /*#__PURE__*/React.createElement(Document, {
      key: item.index,
      file: createBlobUrl.fileBlob
    }, /*#__PURE__*/React.createElement(Page, {
      pageNumber: item.index,
      renderAnnotationLayer: false,
      renderTextLayer: false,
      loading: /*#__PURE__*/React.createElement("div", {
        className: styles.pdfLoading
      }, "Loading"),
      width: 60
    })));
  }
  if (!createBlobUrl) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, "Upload error");
  }
  return (
    /*#__PURE__*/
    // <div className={`${style['custom-node']} ${props.isLongPress || props.checkNodeArr.includes(props.id) ? 'nowheel nopan' : ''}`}>
    React.createElement("div", {
      className: noWheelContainerClass,
      key: createBlobUrl.objectURL
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.pdfContainer
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.previewBox,
      style: {
        height: "".concat((_contentSize$height = contentSize === null || contentSize === void 0 ? void 0 : contentSize.height) !== null && _contentSize$height !== void 0 ? _contentSize$height : 0, "px")
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.pdfPreview
    }, previewDataList.value.length > 0 && /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(VirtualList, {
      data: previewDataList.value,
      height: (_contentSize$height2 = contentSize === null || contentSize === void 0 ? void 0 : contentSize.height) !== null && _contentSize$height2 !== void 0 ? _contentSize$height2 : 0,
      itemHeight: 100,
      itemKey: "index",
      onScroll: function onScroll() {}
    }, function (item) {
      return /*#__PURE__*/React.createElement(List.Item, {
        key: item.index
      }, renderItem(item));
    })))), /*#__PURE__*/React.createElement("div", {
      className: styles.contentBox,
      ref: contentRef
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.pdfContent
    }, /*#__PURE__*/React.createElement(Document, {
      file: createBlobUrl.fileBlob,
      onLoadSuccess: function onLoadSuccess(document) {
        return onDocumentLoadSuccess(document.numPages);
      },
      onLoadError: function onLoadError(error) {
        return onDocumentLoadError(error);
      },
      className: styles.pdfDocument
    }, /*#__PURE__*/React.createElement(Page, {
      pageNumber: pageNumber.value,
      className: styles.pdfPage,
      renderAnnotationLayer: false,
      renderTextLayer: false,
      loading: /*#__PURE__*/React.createElement("div", {
        className: styles.pdfLoading
      }, "Loading"),
      scale: pageScale.value,
      onLoadError: function onLoadError(error) {
        return onPageLoadError(error);
      },
      onLoadSuccess: function onLoadSuccess(page) {
        return onPageLoadSuccess(page.originalWidth, page.originalHeight);
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "".concat(styles.pdfPagePane, " ").concat(documentLoaded.value ? styles.pdfPagePaneDisplay : styles.pdfPagePaneHidden)
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.pdfPrev,
      onClick: function onClick() {
        return handleDocumentPrev();
      }
    }, /*#__PURE__*/React.createElement(PDFPrev, {
      stroke: pageNumber.value <= 1 ? "#020C261A" : "#12192B"
    })), /*#__PURE__*/React.createElement("div", {
      className: styles.pdfPageNum
    }, pageNumber.value, " / ", numPages.value), /*#__PURE__*/React.createElement("div", {
      className: styles.pdfNext,
      onClick: function onClick() {
        return handleDocumentNext();
      }
    }, /*#__PURE__*/React.createElement(PDFNext, {
      stroke: pageNumber.value >= numPages.value ? "#020C261A" : "#12192B"
    }))))))
  );
}